
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-seekers/candidate-faq",
      function () {
        return require("private-next-pages/job-seekers/candidate-faq/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job-seekers/candidate-faq"])
      });
    }
  